import { TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { CAMPAIGN_FORM_TITLE } from '~/constants/campaign'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import {
  CampaignCategory,
  CampaignCostHandlingMethod,
  FormatVersion,
  ReviewSection,
  ReviewTarget,
} from '~/generated/graphql'
import { z } from 'zod'
import { categoryField } from './type'
import { ValidationErrorMessage } from '~/components/common/ValidationErrorMessage'

export const guidanceSchemaFields = {
  guidance: z.string(),
  costHandlingMethod: z.nativeEnum(CampaignCostHandlingMethod),
  ...categoryField,
}
export const validateGuidance = (data: z.infer<typeof guidanceSchema>, ctx: z.RefinementCtx) => {
  if (data.costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign && !data.guidance) {
    ctx.addIssue({
      path: ['guidance'],
      code: z.ZodIssueCode.custom,
      message: '立替型を選択している場合は、ご案内を入力してください',
    })
  }
}

export const guidanceSchema = z.object(guidanceSchemaFields)

export const Guidance = ({ description, tooltip }: CampaignInputComponentProps) => {
  const { control, watch } = useFormContext<z.infer<typeof guidanceSchema>>()
  const costHandlingMethod = watch('costHandlingMethod')
  const category = watch('category')

  return (
    <CampaignInputComponent
      title={CAMPAIGN_FORM_TITLE.guidance}
      review={{
        section: ReviewSection.Campaign,
        targets: [ReviewTarget.Guidance, ReviewTarget.LegalGuidance],
      }}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
      description={description}
      tooltip={tooltip}
      required={costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign}
    >
      <Controller
        name="guidance"
        control={control}
        render={({ field: { ref, ...field }, fieldState }) => {
          return (
            <TextField
              multiline
              minRows={5}
              fullWidth
              placeholder={
                costHandlingMethod === CampaignCostHandlingMethod.NoChargeCampaign
                  ? category === CampaignCategory.Service
                    ? '当日は動きやすい服装でお越しください。'
                    : '商品はクール便で発送しますのでお受け取りにご注意ください。'
                  : ''
              }
              error={!!fieldState.error}
              helperText={<ValidationErrorMessage error={fieldState.error?.message} />}
              inputRef={ref}
              {...field}
            />
          )
        }}
      />
    </CampaignInputComponent>
  )
}
